import { ColDef } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';

const cellStyleCentered = {
    display: 'flex',
    alignItems: 'center',
};

const defaultColDefParams = {
    sortable: true,
};

export const useGetColumnDefs = (isNew: boolean): ColDef[] => {
    const { t } = useTranslation();
    return [
        {
            field: 'software',
            headerName: t('support.clientConfiguration.integrations.software'),
            width: 200,
            ...defaultColDefParams,
            valueGetter(params) {
                const { software } = params.data;
                return t(`mappings.${software.toLowerCase()}`);
            },
        },
        {
            field: 'function',
            headerName: t('support.clientConfiguration.integrations.type'),
            ...defaultColDefParams,
            width: 200,
            valueGetter(params) {
                const func = params.data.function;
                return t(`integrations.${func}`);
            },
        },
        {
            field: 'isActive',
            headerName: t('support.clientConfiguration.integrations.isActive'),
            ...defaultColDefParams,
            width: 150,
            cellRenderer: 'booleanCellRenderer',
            cellStyle: cellStyleCentered,
            hide: isNew,
        },
        {
            field: 'lastExtractionDate',
            headerName: t(
                'support.clientConfiguration.integrations.lastExtractionDate',
            ),
            width: 200,
            hide: isNew,
            ...defaultColDefParams,
        },
        {
            field: 'lastValidExtractionDate',
            headerName: t(
                'support.clientConfiguration.integrations.lastValidExtractionDate',
            ),
            width: 250,
            hide: isNew,
            ...defaultColDefParams,
        },
    ];
};
